export default "__VITE_ASSET__9b4AkYwy__"